<template>
  <el-dialog :title="$t('common.addresses.AddNewAddress')" :modal="modal" :visible.sync="addressFormVisible" @open="open" @close="close" :before-close="close">
  <el-form ref="addressForm" :model="currentAddress" :rules="rules">
    <el-form-item :label="$t('common.addresses.AddressType')" prop="type">
      <el-select
        v-model="currentAddress.type"
        filterable
        value-key="id">
        <el-option
          v-for="item in addressType"
          :key="item.id"
          :label="item.name"
          :value="item">
        </el-option>
      </el-select>
    </el-form-item>
      <el-form-item :label="$t('common.addresses.Address')">
        <el-input v-model="currentAddress.street" :placeholder="$t('common.addresses.Address')"></el-input>
      </el-form-item>
      <el-form-item style="margin-bottom:0px">
        <el-col :span="11">
          <el-form-item :label="$t('common.addresses.City')">
            <el-input v-model="currentAddress.city" :placeholder="$t('common.addresses.City')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11" :offset="2">
          <el-form-item :label="$t('common.addresses.PostalCode')">
            <el-input v-model="currentAddress.postal_code" :placeholder="$t('common.addresses.PostalCode')"></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-col :span="11" >
            <el-form-item  prop="country" :label="$t('common.addresses.Country')">
              <el-select
                v-model="currentAddress.country"
                filterable
                :placeholder="$t('common.addresses.Country')"
                @change="getStates(currentAddress.country.id)"
                value-key="id">
                <el-option
                  v-for="item in countries"
                  :key="item.id"
                  :label="item.name"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11" :offset="2">
            <el-form-item :label="$t('common.addresses.State')" v-if="(this.currentAddress.country==null || this.currentAddress.country!=null && this.currentAddress.country.id<3)">
              <el-select
                v-model="currentAddress.state"
                filterable
                :disabled="currentAddress.country==null"
                value-key="id">
                <el-option
                  v-for="item in states"
                  :key="item.id"
                  :label="item.name"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Province / État / Région" v-if="currentAddress.country!=null && currentAddress.country.id>2">
              <el-input  v-model="currentAddress.other_state"></el-input>
            </el-form-item>
          </el-col>
      </el-form-item>
  </el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="close()">{{$t('common.cancel')}}</el-button>
    <el-button type="primary" @click="addAddress()" v-if="!editionMode">{{ $t('common.add') }}</el-button>
    <el-button type="primary" @click="editAddress()" v-if="editionMode">{{ $t('common.edit') }}</el-button>
  </span>
</el-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import axios from "axios"
export default {
	name: 'AddressEditor',
	props: {
    addressFormVisible: Boolean,
    addressToEdit : Object,
    modal : {
      type : Boolean,
      default : true
    }

	},
	data() {
		return {
        title : "Ajouter une nouvelle adresse",
        existingAdresses : [],
        currentAddress:{},
        states : [],
        editionMode : false,
        rules :{
  				country : [
  	  		 	{ required: true, message: 'Veuillez sélectionner un pays', trigger: 'blur' }
  	  		],
          type : [
  	  		 	{ required: true, message: "Veuillez choisir un type d'addresse", trigger: 'blur' }
  	  		]
        },
        addressType : [{id:1,name:"Facturation"},{id:2,name:"Livraison"},{id:3,name:"Principale"}, {id:4,name:"Correspondance"}],
		}

	},
	computed : {
    ...mapState('controlData',['countries'])
     },
	methods : {
    getStates(country_id){
			axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sys/address/states?countryId="+country_id)
				.then(response=>{
					this.states = response.data;
				}).catch(err=>{
					console.log(err);
				})
		},
    close(){
      this.$emit('close');
      this.currentAddress={};
      this.$refs.addressForm.clearValidate();
    },
    addAddress(){
      this.$refs['addressForm'].validate((valid)=>{
        if(valid){
          this.$emit('add',this.currentAddress);
          }
      });
    },
    editAddress(){
      this.$refs['addressForm'].validate((valid)=>{
        if(valid){
          this.$emit('change',this.currentAddress);
          }
      });
    },
    open(){
      if(this.addressToEdit!=null){
        //Mode edition
        this.editionMode = true;
        this.currentAddress = _.cloneDeep(this.addressToEdit);
        if(this.currentAddress.country!=null && this.currentAddress.country.id<3){
          this.getStates(this.currentAddress.country.id);
        }
      }else{
        //Mode Création
        this.editionMode = false;
      }
    },
    ...mapActions('controlData',['fetchCountries'])
	},
  created(){
    this.fetchCountries();
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/_variables';

.el-select{
	width:100%;
}



</style>
